// extracted by mini-css-extract-plugin
export default {"logoutButton":"LogoutButton_logoutButton__BsIWN","standalone":"LogoutButton_standalone__cOqc+"};